import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  ApiService,
  IListData,
} from 'src/app/shared/services/api/api/api.service';
import { ToasterService } from 'src/app/shared/services/toaster/toaster.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-player-details',
  templateUrl: './player-details.component.html',
  styleUrls: ['./player-details.component.scss'],
})
export class PlayerDetailsComponent implements OnInit, OnDestroy {
  private _routeSub: Subscription;
  player;
  feedbacks: any;
  questionsList: any;
  constructor(
    private _api: ApiService,
    private _cdr: ChangeDetectorRef,
    private _toast: ToasterService,
    private _route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this._routeSub = this._route.params.subscribe((params) => {
      this.getPlayerDetails(params.id);
      // this.getQuestionsList();
    });
  }

  ngOnDestroy(): void {
    this._routeSub.unsubscribe();
  }

  getPlayerDetails(playerId): void {
    this._api.getPlayerById(playerId).subscribe(
      (data) => {
        this.player = data;

        // console.log(this.player, 'player details');
        if (data?.email) {
          this.getFeedbackDetails(data?.email);
        }

        this._cdr.detectChanges();
      },
      (err) => {
        this._toast.showError(err.error.message);
      },
    );
  }
  getFeedbackDetails(email): void {
    this._api.getPlayersFeedback(email).subscribe((res) => {
      // const feedbacks = {
      //   isDeleted: false,
      //   domain: 'all',
      //   _id: '5f686ef9d973489291385bcb',
      //   divisionId: {
      //     _id: '5efc2d2d61c1790012b81cda',
      //     name: 'Demo',
      //     companyId: {
      //       _id: '5efc2cfb61c1790012b81cd9',
      //       name: 'General Demo Company',
      //     },
      //   },
      //   email: 'newtest@talentlitmus.com',
      //   masterGameId: {
      //     _id: '5efc2e8c61c1790012b81cdd',
      //     name: 'General Demo Game',
      //   },
      //   feedback: [
      //     {
      //       _id: '5f686ef9d973489291385bcc',
      //       questionId: '5f686126cb8e1e7e15bd6f94',
      //       response: '5',
      //     },
      //     {
      //       _id: '5f686ef9d973489291385bcd',
      //       questionId: '5f686126cb8e1e7e15bd6f95',
      //       response: 'Amazing Game',
      //     },
      //     {
      //       _id: '5f686ef9d973489291385bce',
      //       questionId: '5f686126cb8e1e7e15bd6f96',
      //       response: 'yes',
      //     },
      //   ],
      //   createdAt: '2020-09-21T09:14:33.750Z',
      // };
      this.feedbacks = res?.playerFeedback;
      this.questionsList = res?.questionsDetails;

      // console.log(this.feedbacks, feedbacks);
    });
  }

  getQuestionsList(): void {
    this._api.getFeedbackQuestionSetsList({}).subscribe((data: IListData) => {
      this.questionsList = data.list;
    });
  }

  mapQuestions(id): void {
    const question = this.questionsList.find((ele) => ele._id === id);
    return question?.text || id;
  }
}
